import { Input, Button, Space } from 'antd';
import { ThunderboltOutlined } from '@ant-design/icons';
import MDEditor from '@uiw/react-md-editor';

interface Props {
  lang: string;
  isSource: boolean;
  /** Current saved topic id; enables the AI-translate action for saved topics. */
  topicId?: string;
  /** Open the topic translate picker pre-scoped to this language. */
  onTranslate?: () => void;
  title: string;
  content: string;
  onChange: (next: { title: string; content: string }) => void;
}

/** Title + Markdown body editor for a single language. The page owns the
 *  language switcher and the translate modal; this tab just edits one language. */
export function PerLanguageTab({ lang, isSource, topicId, onTranslate, title, content, onChange }: Props) {
  return (
    <Space direction="vertical" style={{ width: '100%' }} size="middle">
      {/* AI translate applies to every non-source language (English is the
          source). Topic content may be machine-translated into any target,
          including bundled zh-Hans. */}
      {!isSource && topicId && (
        <div>
          <Button icon={<ThunderboltOutlined />} onClick={onTranslate}>
            Translate…
          </Button>
          <span style={{ marginLeft: 12, color: '#888', fontSize: 12 }}>
            Translate this topic into {lang} (or pick more languages); the boxes update when it finishes.
          </span>
        </div>
      )}
      <div>
        <div style={{ fontSize: 12, color: '#888', marginBottom: 4 }}>Title</div>
        <Input
          size="large"
          value={title}
          onChange={(e) => onChange({ title: e.target.value, content })}
          placeholder={`Title in ${lang}`}
        />
      </div>
      <div data-color-mode="light">
        <MDEditor
          value={content}
          onChange={(v) => onChange({ title, content: v ?? '' })}
          height={400}
          preview="live"
        />
      </div>
    </Space>
  );
}
